import { Route, Routes } from 'react-router-dom'

import type { AgencyModel, CampaignModel } from '@models/types'

import Accounting from './screens/Accounting'
import Activity from './screens/Activity/screens/List'
import AdCopy from './screens/AdCopy'
import ApprovedOrdersList from './screens/Orders/screens/Approved'
import CampaignComparables from './screens/CampaignComparables/screens/List'
import CampaignContactList from './screens/CampaignContacts/screens/List'
import CampaignQuoteEdit from './screens/CampaignQuotes/screens/Edit'
import CampaignQuoteList from './screens/CampaignQuotes/screens/List'
import ConversationList from './screens/Conversations/screens/List'
import DataStore from './screens/DataStore/screens/List'
import EditInvoice from './screens/EditInvoice'
import MediaSelection from './screens/MediaSelection'
import OrderReconciliation from './screens/OrderReconciliation'
import Overview from './screens/Overview'
import PendingOrdersList from './screens/Orders/screens/Pending'
import PhotosAndPlans from './screens/PhotosAndPlans/screens/List'
import PortalData from './screens/PortalData'
import Portals from './screens/Portals'
import PropertyDetails from './screens/PropertyDetails'
import TrackingLinksList from './screens/TrackingLinks'

type CampaignRoutesProps = {
  agency: AgencyModel,
  campaign: CampaignModel,
}

const CampaignRoutes = (props: CampaignRoutesProps) => {
  const { agency, campaign } = props

  return (
    <Routes>
      <Route path="/" element={<Overview agency={agency} campaign={campaign} />} />
      {/*
       // @ts-expect-error TS2322 */}
      <Route path="/accounting" element={<Accounting campaign={campaign} />} />
      <Route path="/accounting/invoices/:invoiceId" element={<EditInvoice campaign={campaign} />} />
      <Route path="/accounting/order-reconciliation" element={<OrderReconciliation />} />
      <Route path="/activity" element={<Activity campaign={campaign} />} />
      <Route path="/adCopy" element={<AdCopy />} />
      <Route path="/quotes" element={<CampaignQuoteList agency={agency} campaign={campaign} />} />
      <Route
        path="/quotes/:campaignQuoteId/edit/*"
        element={<CampaignQuoteEdit campaign={campaign} />}
      />
      <Route path="/comparables" element={<CampaignComparables />} />
      <Route path="/contacts" element={<CampaignContactList />} />
      <Route path="/conversations" element={<ConversationList />} />
      <Route path="/conversations/:conversationId" element={<ConversationList />} />
      <Route path="/data-store" element={<DataStore />} />
      <Route path="/details" element={<PropertyDetails />} />
      <Route path="/orders" element={<PendingOrdersList campaign={campaign} />} />
      <Route path="/orders/approved" element={<ApprovedOrdersList campaign={campaign} />} />
      <Route path="/orders/pending" element={<PendingOrdersList campaign={campaign} />} />
      <Route path="/portals" element={<Portals />} />
      <Route path="/portal-data" element={<PortalData />} />
      <Route path="/media" element={<PhotosAndPlans />} />
      <Route path="/media-selection" element={<MediaSelection campaign={campaign} />} />
      <Route path="/tracking-links" element={<TrackingLinksList />} />
    </Routes>
  )
}

export default CampaignRoutes
